import React, { useRef, useEffect } from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import ButtonBase from '@mui/material/ButtonBase';
import moment from 'moment';

type HorizontalDateStripProps = {
  dates: string[];
  selectedDate: string;
  onSelectDate: (date: string) => void;
};

export const HorizontalDateStrip = ({ dates, selectedDate, onSelectDate }: HorizontalDateStripProps) => {
  const scrollRef = useRef<HTMLDivElement>(null);
  const selectedRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    if (selectedRef.current && scrollRef.current) {
      selectedRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'center',
      });
    }
  }, [selectedDate]);

  return (
    <Grid
      ref={scrollRef}
      container
      flexWrap="nowrap"
      gap={1}
      sx={{
        overflowX: 'auto',
        py: 1,
        scrollbarWidth: 'none',
        '&::-webkit-scrollbar': { display: 'none' },
      }}>
      {dates.map((date) => {
        const m = moment(date);
        const isSelected = date === selectedDate;

        return (
          <ButtonBase
            key={date}
            ref={isSelected ? selectedRef : undefined}
            onClick={() => onSelectDate(date)}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              minWidth: 52,
              py: 1,
              px: 1.5,
              borderRadius: 2,
              backgroundColor: isSelected ? 'text.primary' : 'transparent',
              color: isSelected ? 'background.paper' : 'text.primary',
              transition: 'background-color 0.2s',
            }}>
            <Typography variant="h6" fontWeight={600} lineHeight={1.2}>
              {m.format('D')}
            </Typography>
            <Typography variant="caption" sx={{ opacity: isSelected ? 1 : 0.7 }}>
              {m.format('dd')}
            </Typography>
          </ButtonBase>
        );
      })}
    </Grid>
  );
};
